// ============================================
// PIVOT PUZZLE DATABASE - AUDITED VERSION
// ============================================
// Total Puzzles: 58
// Total Words: ~4,350
// Audited: January 2026
//
// Rules Applied:
// ✅ Two-word phrases only
// ✅ Compound words (closed, open, hyphenated)
// ✅ Common collocations
// ✅ "Mom Test" - 80% recognition
// ❌ Suffixes removed (-ful, -less, -ing, -ed, -er, -en, -ly)
// ❌ Vulgar/offensive removed
// ❌ Obscure/archaic removed
// ❌ Technical jargon removed
// ❌ Proper nouns/brands removed
// ============================================

const uniquePuzzles = [
  // ============================================
  // EASY PUZZLES
  // ============================================

  // AIR - 69 words (27 before + 42 after)
  {
    pivotWord: "AIR",
    difficulty: "easy",
    hints: [
      "Think about temperature and weather conditions",
      "Consider travel and transportation",
      "What household items use this word?"
    ],
    validBefore: [
      "hot", "open", "fresh", "mid", "thin", "cold", "foul", "fair", "cool", "warm",
      "stale", "crisp", "clean", "clear", "dry", "damp", "humid", "dusty", "smoky",
      "night", "mountain", "sea", "ocean", "morning", "still", "compressed", "liquid"
    ],
    validAfter: [
      "bag", "base", "borne", "bus", "craft", "drop", "fare", "field", "flow", "force",
      "head", "line", "mail", "plane", "port", "ship", "tight", "time", "wave", "way",
      "brake", "conditioner", "freshener", "guitar", "horn", "lift", "lock", "mattress",
      "pocket", "pressure", "pump", "raid", "rifle", "show", "space", "speed", "stream",
      "strike", "supply", "tank", "traffic", "vent"
    ]
  },

  // BACK - 96 words (42 before + 54 after)
  {
    pivotWord: "BACK",
    difficulty: "easy",
    hints: [
      "Think about actions and movements",
      "Consider body parts and sports",
      "What about returning or reversing?"
    ],
    validBefore: [
      "cut", "come", "flash", "feed", "pay", "fall", "draw", "hold", "pull", "set",
      "kick", "quarter", "buy", "call", "cash", "fight", "get", "give", "hard", "hit",
      "horse", "hump", "laid", "lean", "look", "paper", "pig", "play", "push", "roll",
      "snap", "splash", "strike", "switch", "talk", "think", "throw", "tie", "touch",
      "turn", "win", "bounce"
    ],
    validAfter: [
      "bone", "fire", "pack", "up", "ground", "yard", "hand", "stage", "drop", "track",
      "lash", "log", "ache", "beat", "bench", "bite", "board", "country", "court", "date",
      "door", "draft", "end", "field", "flip", "flow", "gammon", "hoe", "land", "lit",
      "load", "order", "pedal", "rest", "room", "seat", "side", "slash", "slide", "space",
      "spin", "splash", "stab", "stop", "story", "street", "stretch", "stroke", "swing",
      "talk", "tax", "water", "woods"
    ]
  },

  // BALL - 66 words (53 before + 13 after)
  {
    pivotWord: "BALL",
    difficulty: "easy",
    hints: [
      "Think about different sports",
      "Consider shapes and objects",
      "What games use balls?"
    ],
    validBefore: [
      "base", "basket", "beach", "cannon", "eye", "foot", "gum", "hand", "kick", "meat",
      "odd", "pin", "snow", "soft", "volley", "fire", "crystal", "bean", "bocce", "cotton",
      "curve", "dodge", "dung", "eight", "fair", "fast", "foul", "fur", "golf", "goof",
      "hair", "high", "jump", "low", "match", "medicine", "moth", "net", "paint", "play",
      "polo", "puff", "punch", "racquet", "screw", "spit", "stink", "stress", "tennis",
      "tether", "track", "whiffle"
    ],
    validAfter: [
      "boy", "game", "park", "player", "room", "point", "gown", "cap", "field",
      "handler", "hawk", "pen", "carrier"
    ]
  },

  // BIG - 58 words (9 before + 49 after)
  {
    pivotWord: "BIG",
    difficulty: "easy",
    hints: [
      "Think about size and importance",
      "Consider family members and roles",
      "What things are notably large?"
    ],
    validBefore: [
      "think", "talk", "dream", "go", "play", "act", "live", "spend", "swing"
    ],
    validAfter: [
      "foot", "head", "horn", "mouth", "wig", "shot", "time", "bang", "band", "bird",
      "board", "box", "brother", "budget", "business", "cat", "cheese", "city", "daddy",
      "data", "deal", "dipper", "dog", "ear", "fish", "game", "gun", "hair", "hand",
      "heart", "house", "idea", "league", "mac", "mama", "man", "money", "name", "noise",
      "one", "picture", "screen", "sister", "sky", "spender", "stick", "ticket", "top",
      "wheel"
    ]
  },

  // BREAK - 74 words (51 before + 23 after)
  {
    pivotWord: "BREAK",
    difficulty: "easy",
    hints: [
      "Think about pauses and rest times",
      "Consider things that can be broken",
      "What types of interruptions exist?"
    ],
    validBefore: [
      "lunch", "coffee", "spring", "prison", "tax", "day", "ice", "work", "fast",
      "commercial", "page", "heart", "jaw", "tie", "lucky", "back", "brain", "career",
      "circuit", "city", "clean", "code", "college", "comfort", "dawn", "even", "fire",
      "ground", "habit", "home", "house", "jail", "leg", "light", "line", "luck",
      "mental", "neck", "nerve", "news", "night", "out", "point", "price", "rank",
      "record", "rule", "section", "smoke", "station", "story"
    ],
    validAfter: [
      "even", "dance", "fast", "through", "down", "up", "out", "away", "point", "water",
      "neck", "ground", "front", "in", "loose", "off", "open", "room", "time", "wall",
      "wind", "apart", "back", "camp", "fall"
    ]
  },

  // HIGH - 96 words (16 before + 80 after)
  {
    pivotWord: "HIGH",
    difficulty: "easy",
    hints: [
      "Think about body parts and positions",
      "Consider levels and rankings",
      "What things can be elevated?"
    ],
    validBefore: [
      "thigh", "knee", "sky", "waist", "ankle", "arm", "chest", "ear", "eye", "head",
      "hip", "mile", "neck", "record", "shoulder", "sugar"
    ],
    validAfter: [
      "ball", "born", "boy", "brow", "chair", "land", "light", "way", "jack", "five",
      "altitude", "beam", "blood", "board", "bred", "church", "class", "command", "court",
      "definition", "dive", "end", "energy", "fashion", "fidelity", "flier", "flyer",
      "frequency", "gear", "grade", "ground", "handed", "hat", "heeled", "horse", "impact",
      "jinks", "jump", "king", "life", "living", "low", "maintenance", "minded", "noon",
      "octane", "pass", "pitched", "point", "powered", "pressure", "priest", "profile",
      "quality", "ranking", "rise", "riser", "rising", "road", "roller", "school", "seas",
      "speed", "spirited", "spot", "stakes", "standing", "strung", "style", "tech",
      "tension", "test", "tide", "time", "top", "tower", "voltage", "water", "wire", "yield"
    ]
  },

  // LONG - 62 words (17 before + 45 after)
  {
    pivotWord: "LONG",
    difficulty: "easy",
    hints: [
      "Think about time periods",
      "Consider distance and length",
      "What things extend or last?"
    ],
    validBefore: [
      "day", "life", "mile", "week", "year", "all", "era", "foot", "hour", "inch",
      "month", "night", "so", "summer", "way", "winter", "world"
    ],
    validAfter: [
      "boat", "bow", "hand", "horn", "house", "jump", "range", "ship", "shore", "shot",
      "stand", "term", "time", "way", "awaited", "board", "boarding", "cloth", "distance",
      "division", "drink", "face", "form", "gone", "hair", "haul", "john", "lasting",
      "leaf", "legged", "life", "line", "list", "lived", "lost", "neck", "nose", "play",
      "run", "side", "sleeve", "standing", "suffering", "sword", "winded"
    ]
  },

  // NEW - 39 words (4 before + 35 after)
  {
    pivotWord: "NEW",
    difficulty: "easy",
    hints: [
      "Think about beginnings and freshness",
      "Consider places and locations",
      "What things can be renewed?"
    ],
    validBefore: [
      "brand", "like", "shiny", "spanking"
    ],
    validAfter: [
      "born", "comer", "found", "fangled", "blood", "breed", "build", "castle", "deal",
      "england", "face", "growth", "haven", "jersey", "leaf", "look", "man", "math",
      "media", "mexico", "moon", "orleans", "port", "rich", "school", "speak", "stand",
      "style", "testament", "town", "wave", "world", "year", "york", "zealander"
    ]
  },

  // GOOD - 59 words (12 before + 47 after)
  {
    pivotWord: "GOOD",
    difficulty: "easy",
    hints: [
      "Think about greetings and farewells",
      "Consider qualities and character",
      "What describes positive things?"
    ],
    validBefore: [
      "feel", "do", "no", "for", "all", "common", "greater", "highest", "own", "public",
      "real", "social"
    ],
    validAfter: [
      "bye", "night", "will", "looking", "hearted", "morning", "fellow", "afternoon",
      "day", "deal", "deed", "egg", "enough", "evening", "faith", "fortune", "guy",
      "heavens", "grief", "humor", "job", "life", "lord", "luck", "man", "match",
      "measure", "name", "nature", "natured", "news", "old", "one", "riddance",
      "samaritan", "sense", "sport", "standing", "taste", "thing", "thought", "times",
      "tidings", "wishes", "works", "year", "ball"
    ]
  },

  // ============================================
  // MEDIUM PUZZLES
  // ============================================

  // BLACK - 63 words (9 before + 54 after)
  {
    pivotWord: "BLACK",
    difficulty: "medium",
    hints: [
      "Think about colors and shades",
      "Consider animals and nature",
      "What things are commonly dark?"
    ],
    validBefore: [
      "jet", "pitch", "coal", "ink", "carbon", "solid", "flat", "matte", "pure"
    ],
    validAfter: [
      "ball", "berry", "bird", "board", "box", "eye", "fish", "guard", "head", "hole",
      "jack", "list", "mail", "out", "smith", "top", "market", "belt", "book", "cap",
      "cat", "currant", "diamond", "face", "fly", "foot", "forest", "friday", "gold",
      "hand", "hawk", "heart", "leg", "letter", "magic", "mark", "neck", "pearl",
      "pepper", "pool", "power", "pudding", "sheep", "shirt", "snake", "spot", "stone",
      "strap", "swan", "thorn", "tie", "water", "widow"
    ]
  },

  // BLUE - 49 words (14 before + 35 after)
  {
    pivotWord: "BLUE",
    difficulty: "medium",
    hints: [
      "Think about shades and variations",
      "Consider nature and animals",
      "What things are this color?"
    ],
    validBefore: [
      "baby", "cobalt", "dark", "deep", "ice", "light", "midnight", "navy", "pale",
      "powder", "royal", "sky", "steel", "true"
    ],
    validAfter: [
      "bell", "berry", "bird", "blood", "bonnet", "book", "bottle", "boy", "chip",
      "coat", "collar", "crab", "fish", "grass", "jay", "jeans", "line", "moon", "nose",
      "pencil", "point", "print", "ribbon", "screen", "shift", "sky", "state", "stone",
      "streak", "suit", "tail", "throat", "tooth", "water", "whale"
    ]
  },

  // BOOK - 87 words (64 before + 23 after)
  {
    pivotWord: "BOOK",
    difficulty: "medium",
    hints: [
      "Think about types of publications",
      "Consider reading and writing",
      "What kinds of records exist?"
    ],
    validBefore: [
      "address", "audio", "bank", "black", "blue", "case", "check", "children", "class",
      "code", "coffee", "color", "comic", "cook", "copy", "course", "data", "day", "desk",
      "diary", "dictionary", "draft", "dream", "face", "good", "grade", "guide", "gun",
      "hand", "hymn", "log", "match", "memo", "mini", "note", "order", "pass", "phone",
      "phrase", "picture", "play", "pocket", "prayer", "program", "puzzle", "quote",
      "rate", "recipe", "record", "reference", "rule", "scrap", "sketch", "song",
      "source", "spell", "story", "style", "talk", "text", "work", "year"
    ],
    validAfter: [
      "bag", "binder", "case", "club", "end", "fair", "keeper", "let", "maker", "mark",
      "mobile", "plate", "rack", "report", "rest", "review", "seller", "shelf", "shop",
      "stall", "stand", "store", "worm"
    ]
  },

  // BRAIN - 31 words (6 before + 25 after)
  {
    pivotWord: "BRAIN",
    difficulty: "medium",
    hints: [
      "Think about intelligence and thinking",
      "Consider mental activities",
      "What relates to the mind?"
    ],
    validBefore: [
      "bird", "scatter", "feather", "pea", "no"
    ],
    validAfter: [
      "child", "dead", "power", "storm", "wash", "wave", "teaser", "freeze", "trust",
      "box", "cell", "damage", "death", "drain", "fog", "food", "injury", "matter",
      "pan", "pick", "scan", "stem", "surgeon", "surgery", "work"
    ]
  },

  // CARD - 96 words (78 before + 18 after)
  {
    pivotWord: "CARD",
    difficulty: "medium",
    hints: [
      "Think about payment and identification",
      "Consider games and greetings",
      "What kinds of cards exist?"
    ],
    validBefore: [
      "credit", "flash", "green", "post", "score", "wild", "gift", "report", "bank",
      "access", "address", "appointment", "baseball", "birthday", "boarding", "business",
      "calling", "christmas", "club", "computer", "contact", "cue", "dance", "debit",
      "discount", "draft", "draw", "face", "file", "game", "get-well", "gold", "greeting",
      "hand", "health", "high", "hole", "holy", "id", "index", "insurance", "key",
      "library", "lottery", "low", "loyalty", "master", "meal", "member", "memory",
      "menu", "note", "party", "pass", "phone", "place", "playing", "punch", "race",
      "rate", "red", "reward", "scratch", "show", "sim", "smart", "sound", "store",
      "tarot", "time", "top", "trade", "trump", "union", "voting", "warning", "wedding",
      "yellow"
    ],
    validAfter: [
      "board", "holder", "shark", "stock", "game", "table", "file", "house", "index",
      "member", "play", "playing", "punch", "reader", "room", "sharp", "trick", "box",
      "catalog"
    ]
  },

  // CAST - 19 words (13 before + 6 after)
  {
    pivotWord: "CAST",
    difficulty: "medium",
    hints: [
      "Think about throwing and projecting",
      "Consider entertainment and media",
      "What can be molded or shaped?"
    ],
    validBefore: [
      "broad", "down", "fore", "out", "over", "type", "die", "fly", "news", "off",
      "play", "sand", "screen"
    ],
    validAfter: [
      "away", "iron", "off", "about", "aside", "net"
    ]
  },

  // DOOR - 58 words (33 before + 25 after)
  {
    pivotWord: "DOOR",
    difficulty: "medium",
    hints: [
      "Think about types of entrances",
      "Consider parts of a door",
      "What describes different doors?"
    ],
    validBefore: [
      "back", "barn", "car", "cell", "closet", "fire", "floor", "french", "front",
      "garage", "glass", "next", "out", "oven", "pet", "rear", "revolving", "screen",
      "side", "sliding", "stage", "storm", "swing", "trap", "vault", "cabinet", "cellar",
      "church", "cupboard", "hatch", "iron", "prison", "saloon"
    ],
    validAfter: [
      "bell", "frame", "jam", "jamb", "keeper", "knob", "man", "mat", "nail", "plate",
      "post", "prize", "sill", "step", "stop", "way", "handle", "hinge", "holder",
      "knocker", "latch", "lock", "opener", "slam", "spring"
    ]
  },

  // DREAM - 33 words (17 before + 16 after)
  {
    pivotWord: "DREAM",
    difficulty: "medium",
    hints: [
      "Think about sleep and imagination",
      "Consider aspirations and goals",
      "What kinds of dreams exist?"
    ],
    validBefore: [
      "day", "pipe", "wet", "fever", "bad", "lucid", "sweet", "wild", "american",
      "broken", "childhood", "recurring", "impossible", "distant", "lifelong",
      "shattered", "unfulfilled"
    ],
    validAfter: [
      "boat", "catcher", "land", "like", "scape", "team", "world", "work", "big",
      "book", "car", "date", "girl", "house", "job", "man", "sequence"
    ]
  },

  // EYE - 68 words (42 before + 26 after)
  {
    pivotWord: "EYE",
    difficulty: "medium",
    hints: [
      "Think about vision and seeing",
      "Consider types of looks",
      "What describes different eyes?"
    ],
    validBefore: [
      "bird", "black", "blue", "brown", "bull", "cat", "cross", "dead", "dry", "eagle",
      "evil", "fish", "glass", "green", "hawk", "keen", "lazy", "naked", "pink", "pop",
      "private", "red", "shut", "single", "snake", "third", "tiger", "wall", "wandering",
      "watchful", "weather", "bug", "critical", "electric", "googly", "hazel", "human",
      "magic", "public", "sharp", "shifty", "wide"
    ],
    validAfter: [
      "ball", "brow", "cup", "drop", "full", "glass", "hole", "lash", "lid", "liner",
      "opener", "piece", "shadow", "sight", "sore", "strain", "tooth", "wash", "wear",
      "witness", "candy", "contact", "doctor", "level", "patch", "socket"
    ]
  },

  // FACE - 55 words (32 before + 23 after)
  {
    pivotWord: "FACE",
    difficulty: "medium",
    hints: [
      "Think about expressions and appearances",
      "Consider surfaces and fronts",
      "What types of faces exist?"
    ],
    validBefore: [
      "baby", "black", "bold", "brave", "clock", "coal", "dead", "doll", "double",
      "fresh", "game", "happy", "long", "pale", "pie", "plain", "poker", "pretty",
      "public", "sad", "smiley", "straight", "surface", "two", "type", "about", "angel",
      "blank", "funny", "new", "round"
    ],
    validAfter: [
      "book", "card", "cloth", "cream", "down", "lift", "mask", "off", "paint", "plate",
      "time", "value", "first", "guard", "palm", "plant", "print", "recognition", "scan",
      "shield", "swap", "up", "work"
    ]
  },

  // FINGER - 27 words (14 before + 13 after)
  {
    pivotWord: "FINGER",
    difficulty: "medium",
    hints: [
      "Think about hand parts",
      "Consider touch and pointing",
      "What do fingers do?"
    ],
    validBefore: [
      "fore", "index", "little", "middle", "ring", "trigger", "butter", "fish", "gold",
      "green", "lady", "light", "pinkie", "point"
    ],
    validAfter: [
      "board", "bowl", "food", "mark", "nail", "paint", "print", "tip", "hole", "hold",
      "point", "snap", "spell"
    ]
  },

  // FIRE - 77 words (27 before + 50 after)
  {
    pivotWord: "FIRE",
    difficulty: "medium",
    hints: [
      "Think about flames and heat",
      "Consider weapons and combat",
      "What relates to burning?"
    ],
    validBefore: [
      "back", "bon", "brush", "camp", "cease", "cover", "cross", "gun", "hell", "home",
      "miss", "open", "out", "quick", "rapid", "real", "sure", "wild", "wood", "forest",
      "friendly", "grass", "machine", "return", "coal", "enemy", "gas"
    ],
    validAfter: [
      "arm", "ball", "bomb", "brand", "break", "brick", "bug", "cracker", "dog",
      "escape", "fight", "fly", "guard", "house", "light", "man", "place", "plug",
      "power", "proof", "side", "storm", "trap", "truck", "wall", "wood", "work",
      "works", "alarm", "ant", "bird", "boat", "box", "brigade", "chief", "code",
      "damage", "department", "door", "drill", "engine", "exit", "extinguisher",
      "fighter", "hazard", "hose", "hydrant", "line", "pit"
    ]
  },

  // FISH - 71 words (46 before + 25 after)
  {
    pivotWord: "FISH",
    difficulty: "medium",
    hints: [
      "Think about types of fish",
      "Consider fishing and seafood",
      "What describes aquatic life?"
    ],
    validBefore: [
      "cat", "craw", "dog", "flat", "gold", "jelly", "king", "star", "sun", "sword",
      "blow", "cray", "shell", "angel", "bat", "big", "blue", "bottom", "box", "butter",
      "clown", "cod", "cold", "drum", "flying", "fresh", "game", "globe", "ice", "lion",
      "monk", "mud", "pan", "parrot", "pilot", "pipe", "puffer", "raw", "rock", "sail",
      "salt", "silver", "tropical", "weak", "white", "odd"
    ],
    validAfter: [
      "bowl", "cake", "eye", "hook", "man", "market", "monger", "net", "pond", "tail",
      "wife", "tank", "stick", "fry", "ball", "bone", "burger", "finger", "knife",
      "meal", "oil", "paste", "plate", "pole", "sauce"
    ]
  },

  // FOOT - 58 words (22 before + 36 after)
  {
    pivotWord: "FOOT",
    difficulty: "medium",
    hints: [
      "Think about walking and standing",
      "Consider measurements and positions",
      "What relates to feet?"
    ],
    validBefore: [
      "bare", "big", "bird", "black", "club", "crow", "flat", "fore", "hot", "left",
      "right", "tender", "under", "web", "cloven", "fleet", "heavy", "hind", "light",
      "square"
    ],
    validAfter: [
      "ball", "board", "bridge", "fall", "hill", "hold", "lights", "loose", "note",
      "path", "print", "race", "rest", "soldier", "step", "stool", "wear", "work",
      "age", "bath", "brake", "care", "cloth", "drop", "gear", "guard", "locker",
      "man", "mark", "pad", "plate", "pound", "pump", "sore", "traffic", "warmer"
    ]
  },

  // GOLD - 43 words (13 before + 30 after)
  {
    pivotWord: "GOLD",
    difficulty: "medium",
    hints: [
      "Think about precious metals",
      "Consider colors and value",
      "What things are golden?"
    ],
    validBefore: [
      "pot", "solid", "liquid", "fool", "bar", "black", "old", "olympic", "pure",
      "real", "rose", "spun", "white"
    ],
    validAfter: [
      "brick", "coast", "dust", "field", "finch", "fish", "leaf", "mine", "rush",
      "smith", "stone", "digger", "bar", "chain", "coin", "cup", "disc", "foil",
      "lace", "medal", "nugget", "plate", "plated", "pot", "reserve", "ring", "star",
      "standard", "thread", "work"
    ]
  },

  // GREEN - 51 words (27 before + 24 after)
  {
    pivotWord: "GREEN",
    difficulty: "medium",
    hints: [
      "Think about shades and nature",
      "Consider plants and environment",
      "What things are this color?"
    ],
    validBefore: [
      "ever", "sea", "bowling", "lime", "olive", "forest", "mint", "apple", "bottle",
      "dark", "deep", "emerald", "grass", "hunter", "jade", "jungle", "kelly", "leaf",
      "light", "moss", "neon", "pale", "pea", "putting", "sage", "spring", "village"
    ],
    validAfter: [
      "back", "belt", "card", "eye", "fly", "grocer", "horn", "house", "light", "room",
      "thumb", "wood", "peace", "field", "finch", "grass", "hand", "head", "heart",
      "keeper", "land", "mail", "scape", "way"
    ]
  },

  // GROUND - 67 words (39 before + 28 after)
  {
    pivotWord: "GROUND",
    difficulty: "medium",
    hints: [
      "Think about land and earth",
      "Consider foundations and bases",
      "What happens on the ground?"
    ],
    validBefore: [
      "back", "battle", "camp", "fair", "fore", "home", "play", "under", "proving",
      "common", "burial", "above", "ball", "base", "breeding", "burying", "coffee",
      "dead", "dumping", "feeding", "firm", "fishing", "foot", "gain", "grazing",
      "high", "hunting", "middle", "neutral", "parade", "parking", "picnic", "pleasure",
      "practice", "rising", "solid", "spawning", "sports", "stamping"
    ],
    validAfter: [
      "break", "floor", "hog", "nut", "swell", "water", "work", "keeper", "cover",
      "crew", "ball", "beef", "cloth", "control", "effect", "fire", "fish", "force",
      "game", "level", "pepper", "plan", "rule", "sheet", "speed", "squirrel", "wire",
      "zero"
    ]
  },

  // HAND - 87 words (46 before + 41 after)
  {
    pivotWord: "HAND",
    difficulty: "medium",
    hints: [
      "Think about gripping and holding",
      "Consider help and assistance",
      "What involves using hands?"
    ],
    validBefore: [
      "back", "black", "close", "dead", "deck", "farm", "field", "first", "fore", "free",
      "fresh", "glad", "green", "gun", "helping", "hired", "hot", "hour", "left", "long",
      "minute", "off", "old", "open", "over", "ranch", "red", "right", "rough", "second",
      "short", "stage", "steady", "strong", "under", "upper", "whip", "clap", "cow",
      "dab", "dock", "fair", "high", "iron", "middle"
    ],
    validAfter: [
      "bag", "ball", "bell", "bill", "book", "brake", "car", "cart", "cuff", "gun",
      "hold", "made", "maid", "out", "rail", "saw", "shake", "some", "spring", "stand",
      "work", "writing", "bar", "basket", "blown", "cap", "clap", "clasp", "craft",
      "cream", "feed", "grip", "kerchief", "knit", "labor", "maiden", "over", "picked",
      "print", "puppet", "set"
    ]
  },

  // HEAD - 115 words (68 before + 47 after)
  {
    pivotWord: "HEAD",
    difficulty: "medium",
    hints: [
      "Think about leadership and tops",
      "Consider body parts and positions",
      "What leads or comes first?"
    ],
    validBefore: [
      "air", "arrow", "bed", "beef", "big", "block", "bone", "bull", "butter", "copper",
      "dead", "drum", "dumb", "egg", "fat", "figure", "flat", "fore", "gear", "god",
      "hammer", "hard", "hot", "jug", "knuckle", "letter", "log", "mail", "mast", "meat",
      "nail", "over", "pig", "pin", "pit", "pot", "print", "rail", "red", "river",
      "round", "sap", "sea", "sheep", "show", "skin", "sleepy", "soft", "sore", "spear",
      "speed", "spring", "steam", "tow", "war", "white", "wooden", "axe", "bald", "bird",
      "blank", "board"
    ],
    validAfter: [
      "ache", "band", "board", "light", "line", "phone", "set", "way", "strong", "first",
      "master", "note", "piece", "pin", "quarters", "rest", "room", "sail", "scarf",
      "shot", "spin", "spring", "stall", "stand", "start", "stock", "stone", "trip",
      "wall", "waters", "wind", "word", "work", "count", "dress", "gate", "gear",
      "hunter", "lamp", "land", "lock", "long", "man", "mistress", "on", "waiter"
    ]
  },

  // HEART - 72 words (43 before + 29 after)
  {
    pivotWord: "HEART",
    difficulty: "medium",
    hints: [
      "Think about emotions and feelings",
      "Consider the organ and health",
      "What describes different hearts?"
    ],
    validBefore: [
      "sweet", "brave", "lion", "faint", "soft", "cold", "whole", "dear", "big",
      "bleeding", "broken", "caring", "chicken", "cross", "dead", "false", "fickle",
      "flint", "good", "great", "half", "hard", "heavy", "iron", "kind", "light",
      "lonely", "open", "purple", "pure", "queen", "sacred", "single", "stone", "stout",
      "strong", "tender", "tiger", "true", "warm", "weak", "wild", "young"
    ],
    validAfter: [
      "ache", "beat", "break", "broken", "burn", "felt", "land", "throb", "warm", "sick",
      "strings", "attack", "blood", "breaker", "failure", "free", "grief", "heavy",
      "line", "rate", "shaped", "stopping", "struck", "surgery", "swap", "transplant",
      "trouble", "warming", "wood"
    ]
  },

  // HOUSE - 156 words (103 before + 53 after)
  {
    pivotWord: "HOUSE",
    difficulty: "medium",
    hints: [
      "Think about types of buildings",
      "Consider home and residence",
      "What kinds of houses exist?"
    ],
    validBefore: [
      "bird", "club", "dog", "doll", "fire", "full", "green", "light", "tree", "ware",
      "ale", "animal", "auction", "bake", "bath", "beach", "beer", "boarding", "boat",
      "book", "brew", "brick", "chart", "chop", "church", "clearing", "coach", "coffee",
      "cottage", "country", "court", "custom", "deck", "dream", "drug", "engine", "farm",
      "fashion", "field", "fun", "funeral", "gate", "glass", "god", "guest", "guard",
      "gun", "halfway", "hash", "haunted", "hen", "hot", "ice", "jail", "lake", "log",
      "long", "mad", "manor", "meeting", "mill", "motor", "nut", "open", "opera", "out",
      "pack", "pancake", "parish", "pest", "pilot", "play", "pool", "poor", "porter",
      "post", "pot", "power", "press", "prison", "public", "pump", "ranch", "road",
      "round", "row", "safe", "school", "slaughter", "smoke", "state", "steak", "store",
      "summer", "tea", "toll", "town", "treasure", "wheel", "white", "work"
    ],
    validAfter: [
      "boat", "coat", "fly", "hold", "keeper", "maid", "mate", "wife", "work", "plant",
      "arrest", "bound", "boy", "break", "breaker", "call", "cat", "clean", "cleaning",
      "dress", "fire", "front", "girl", "guest", "hunting", "husband", "keeping", "key",
      "lights", "line", "man", "martin", "master", "mother", "paint", "painter", "parent",
      "party", "pet", "proud", "room", "rules", "sale", "sit", "sitter", "sitting",
      "top", "trained", "ware", "wares", "warm", "warming"
    ]
  },

  // ICE - 87 words (25 before + 62 after)
  {
    pivotWord: "ICE",
    difficulty: "medium",
    hints: [
      "Think about cold and frozen",
      "Consider winter activities",
      "What involves ice?"
    ],
    validBefore: [
      "black", "dry", "thin", "pack", "sheet", "blue", "clear", "crushed", "drift",
      "glare", "ground", "lake", "pancake", "polar", "rock", "sea", "shaved", "shelf",
      "slush", "solid", "spray", "surface", "thick", "water", "white"
    ],
    validAfter: [
      "berg", "box", "breaker", "cap", "cold", "cream", "cube", "land", "man", "pack",
      "pick", "skate", "water", "hockey", "axe", "bag", "ball", "bath", "block", "boat",
      "bound", "bucket", "burn", "chest", "chip", "climbing", "coffee", "covered",
      "dancing", "drift", "fall", "field", "fish", "fishing", "floe", "fog", "foot",
      "free", "front", "house", "jam", "lolly", "machine", "maker", "milk", "out",
      "over", "palace", "pop", "queen", "rink", "road", "sculpture", "shelf", "sheet",
      "show", "slide", "storm", "tea", "tray", "wine", "yacht"
    ]
  },

  // KEY - 50 words (26 before + 24 after)
  {
    pivotWord: "KEY",
    difficulty: "medium",
    hints: [
      "Think about locks and access",
      "Consider music and typing",
      "What kinds of keys exist?"
    ],
    validBefore: [
      "pass", "car", "church", "door", "drum", "entry", "escape", "function", "high",
      "hot", "house", "ignition", "lock", "low", "major", "master", "minor", "off",
      "piano", "primary", "room", "safe", "shift", "skeleton", "spare", "valet"
    ],
    validAfter: [
      "board", "chain", "hole", "note", "pad", "stone", "word", "stroke", "ring",
      "card", "case", "code", "cut", "fob", "frame", "grip", "guard", "holder", "hook",
      "lime", "man", "punch", "smith", "way"
    ]
  },

  // LIGHT - 100 words (79 before + 21 after)
  {
    pivotWord: "LIGHT",
    difficulty: "medium",
    hints: [
      "Think about illumination and brightness",
      "Consider weight and colors",
      "What types of lights exist?"
    ],
    validBefore: [
      "arc", "black", "blue", "bright", "broad", "candle", "day", "dim", "down", "first",
      "flash", "flood", "green", "half", "head", "high", "lamp", "lime", "low", "moon",
      "night", "pen", "pilot", "port", "red", "search", "side", "sky", "spot", "star",
      "stop", "street", "strip", "sun", "tail", "torch", "traffic", "twilight", "ultra",
      "ambient", "artificial", "back", "beam", "brake", "ceiling", "dash", "electric",
      "emergency", "exit", "fairy", "fire", "floor", "fluorescent", "fog", "foot",
      "front", "gas", "glow", "guiding", "hall", "harsh", "hazard", "house",
      "incandescent", "indicator", "interior", "landing", "laser", "neon", "porch",
      "reading", "rear", "recessed", "ring", "runway", "safety", "sea"
    ],
    validAfter: [
      "bulb", "house", "ship", "weight", "year", "beam", "box", "face", "head", "post",
      "proof", "rail", "room", "saber", "show", "source", "speed", "switch", "wave",
      "work"
    ]
  },

  // LINE - 129 words (115 before + 14 after)
  {
    pivotWord: "LINE",
    difficulty: "medium",
    hints: [
      "Think about boundaries and queues",
      "Consider communication and text",
      "What kinds of lines exist?"
    ],
    validBefore: [
      "air", "assembly", "base", "blood", "blue", "border", "bottom", "branch", "bus",
      "by", "center", "chorus", "city", "clothes", "coast", "color", "command",
      "contour", "credit", "cruise", "date", "dead", "decline", "defense", "dotted",
      "down", "drawn", "dress", "drive", "drop", "fault", "feed", "fence", "finishing",
      "fire", "first", "fishing", "flight", "fold", "food", "front", "fuel", "gas",
      "goal", "guide", "hair", "hard", "head", "help", "high", "hot", "land", "lead",
      "life", "main", "mid", "net", "off", "on", "out", "over", "party", "pass", "phone",
      "pick", "picket", "pipe", "plot", "plumb", "police", "poll", "poverty", "power",
      "production", "profit", "property", "punch", "rail", "rain", "red", "ridge",
      "roof", "service", "shore", "side", "sight", "sky", "snow", "solid", "song",
      "state", "story", "straight", "stream", "strip", "supply", "tag", "tan",
      "telephone", "thin", "throw", "tide", "time", "toe", "top", "touch", "tow",
      "tree", "trend", "truck", "trunk", "waist", "waiting", "water", "zip"
    ],
    validAfter: [
      "age", "back", "drive", "man", "up", "item", "break", "card", "cook", "dance",
      "feed", "graph", "haul", "out"
    ]
  },

  // LOW - 57 words (15 before + 42 after)
  {
    pivotWord: "LOW",
    difficulty: "medium",
    hints: [
      "Think about levels and positions",
      "Consider records and minimums",
      "What describes being down?"
    ],
    validBefore: [
      "all-time", "record", "ultra", "super", "new", "career", "historic", "down", "fly",
      "lie", "near", "rock", "all", "extreme", "lay"
    ],
    validAfter: [
      "born", "brow", "down", "land", "life", "key", "rider", "ball", "cost", "budget",
      "fat", "tide", "profile", "altitude", "back", "beam", "blow", "boy", "bred",
      "calorie", "carb", "carbon", "church", "class", "cut", "end", "energy",
      "frequency", "gear", "grade", "impact", "income", "interest", "level",
      "maintenance", "pitched", "point", "powered", "pressure", "priced", "rent", "rise"
    ]
  },

  // MIND - 54 words (39 before + 15 after)
  {
    pivotWord: "MIND",
    difficulty: "medium",
    hints: [
      "Think about thinking and intellect",
      "Consider attitudes and opinions",
      "What describes mental states?"
    ],
    validBefore: [
      "master", "never", "hive", "open", "single", "narrow", "small", "like", "broad",
      "free", "absent", "bear", "blow", "change", "close", "conscious", "creative",
      "criminal", "curious", "dirty", "evil", "frame", "group", "guilty", "healthy",
      "human", "inquiring", "keep", "lose", "make", "one-track", "peace", "presence",
      "read", "right", "sharp", "simple", "sound", "speak"
    ],
    validAfter: [
      "set", "blowing", "bending", "boggling", "reader", "field", "game", "map", "meld",
      "blank", "body", "control", "frame", "reading", "share"
    ]
  },

  // MOON - 63 words (20 before + 43 after)
  {
    pivotWord: "MOON",
    difficulty: "medium",
    hints: [
      "Think about lunar phases",
      "Consider night and space",
      "What relates to the moon?"
    ],
    validBefore: [
      "full", "half", "new", "blue", "crescent", "dark", "first", "harvest", "honey",
      "last", "pale", "quarter", "rising", "setting", "silver", "waning", "waxing",
      "blood", "cold", "super"
    ],
    validAfter: [
      "beam", "light", "rise", "set", "shine", "stone", "struck", "walk", "base", "bath",
      "blind", "boot", "bounce", "bow", "cake", "child", "dial", "dog", "dust", "eye",
      "face", "fall", "fish", "flower", "glow", "goddess", "landing", "less", "like",
      "lit", "man", "phase", "pie", "pool", "quake", "ray", "rock", "roof", "scape",
      "seed", "shadow", "shot"
    ]
  },

  // OVER - 185 words (86 before + 99 after)
  {
    pivotWord: "OVER",
    difficulty: "medium",
    hints: [
      "Think about exceeding and crossing",
      "Consider endings and completions",
      "What goes above or beyond?"
    ],
    validBefore: [
      "all", "boil", "bowl", "carry", "change", "cloud", "comb", "come", "cover", "cross",
      "cut", "discover", "do", "draw", "dub", "drive", "flip", "flow", "fly", "game",
      "get", "give", "go", "grow", "hand", "hang", "hold", "hunt", "jump", "keep",
      "knock", "land", "lay", "lean", "leave", "left", "let", "lift", "look", "lord",
      "make", "move", "pass", "pay", "play", "power", "pull", "push", "put", "reach",
      "ride", "roll", "rule", "run", "see", "sell", "set", "shoot", "skip", "sleep",
      "slip", "spill", "stand", "stay", "step", "stop", "storm", "switch", "take",
      "talk", "think", "throw", "tip", "top", "turn", "voice", "walk", "watch", "weigh",
      "whelm", "wind", "work", "write", "more", "twice"
    ],
    validAfter: [
      "all", "arch", "arm", "awe", "bear", "bid", "bite", "blown", "board", "bold",
      "book", "bore", "borne", "bought", "brim", "build", "burden", "came", "capacity",
      "cast", "charge", "claim", "coat", "come", "compensate", "confident", "cook",
      "crowded", "develop", "do", "done", "dose", "draft", "draw", "dressed", "drive",
      "due", "eat", "estimate", "extend", "feed", "fill", "fish", "flow", "grown",
      "hang", "haul", "head", "hear", "heat", "indulge", "joyed", "kill", "land", "lap",
      "lay", "leap", "load", "look", "lord", "man", "master", "night", "paid", "pass",
      "play", "population", "power", "price", "print", "produce", "protect", "qualified",
      "rate", "reach", "react", "ride", "ripe", "rule", "run", "seas", "see", "shadow",
      "shoot", "sight", "simplify", "sleep", "spend", "spill", "spread", "state", "stay",
      "step", "stock", "stretch", "stuff"
    ]
  },

  // PLAY - 62 words (35 before + 27 after)
  {
    pivotWord: "PLAY",
    difficulty: "medium",
    hints: [
      "Think about games and sports",
      "Consider entertainment and theater",
      "What involves playing?"
    ],
    validBefore: [
      "air", "by", "child", "dis", "down", "end", "fair", "fore", "foul", "free", "fun",
      "gun", "horse", "inter", "long", "match", "mis", "out", "over", "pass", "power",
      "pre", "re", "role", "screen", "short", "stage", "sword", "team", "under", "word",
      "ball", "cold", "double", "grand"
    ],
    validAfter: [
      "back", "bill", "book", "boy", "date", "day", "ground", "house", "land", "list",
      "maker", "mate", "off", "pen", "room", "school", "script", "suit", "thing", "time",
      "wright", "act", "acting", "along", "down", "girl", "goer"
    ]
  },

  // POINT - 72 words (66 before + 6 after)
  {
    pivotWord: "POINT",
    difficulty: "medium",
    hints: [
      "Think about tips and ends",
      "Consider scores and locations",
      "What kinds of points exist?"
    ],
    validBefore: [
      "ball", "blue", "break", "check", "dew", "end", "flash", "gun", "high", "pin",
      "stand", "view", "focal", "power", "access", "action", "boiling", "bonus",
      "brownie", "bullet", "cardinal", "center", "counter", "critical", "data",
      "decimal", "departure", "dry", "duty", "entry", "exit", "fixed", "float",
      "freezing", "grade", "half", "knife", "low", "match", "meeting", "melting", "mid",
      "needle", "observation", "percentage", "pivot", "pressure", "price", "rallying",
      "reference", "selling", "set", "starting", "stick", "strong", "talking", "tipping",
      "touch", "trigger", "turning", "vanishing", "vantage", "weak", "west", "code"
    ],
    validAfter: [
      "blank", "break", "man", "guard", "spread", "system"
    ]
  },

  // POWER - 89 words (48 before + 41 after)
  {
    pivotWord: "POWER",
    difficulty: "medium",
    hints: [
      "Think about energy and strength",
      "Consider authority and control",
      "What generates or uses power?"
    ],
    validBefore: [
      "air", "brain", "fire", "horse", "man", "sea", "solar", "super", "will", "wind",
      "nuclear", "hydro", "atomic", "backup", "battery", "black", "buying", "candle",
      "coal", "computing", "diesel", "earning", "electric", "emergency", "engine",
      "flower", "fuel", "gas", "generator", "girl", "gun", "heating", "high", "laser",
      "low", "main", "market", "military", "muscle", "oil", "pedal", "people", "police",
      "processing", "reserve", "soft", "star"
    ],
    validAfter: [
      "boat", "house", "play", "lift", "plant", "line", "outage", "surge", "trip",
      "ball", "base", "broker", "cable", "center", "cord", "cut", "drill", "drive",
      "driven", "failure", "forward", "grab", "grid", "hungry", "lock", "lunch", "mad",
      "move", "nap", "off", "on", "pack", "point", "politics", "press", "saw", "sharing",
      "shift", "slide", "source"
    ]
  },

  // RAIN - 51 words (19 before + 32 after)
  {
    pivotWord: "RAIN",
    difficulty: "medium",
    hints: [
      "Think about weather and precipitation",
      "Consider protection from rain",
      "What involves water falling?"
    ],
    validBefore: [
      "acid", "brain", "heavy", "light", "spring", "steady", "torrential", "cold",
      "constant", "driving", "fine", "freezing", "gentle", "hard", "monsoon", "overnight",
      "pouring", "sudden", "warm"
    ],
    validAfter: [
      "bow", "check", "coat", "drop", "fall", "forest", "maker", "proof", "storm",
      "water", "bird", "bound", "cloud", "dance", "day", "delay", "drain", "gauge",
      "gear", "god", "hat", "out", "shower", "slick", "soaked", "spout", "squall",
      "swept", "wash", "wear", "worm", "zone"
    ]
  },

  // RED - 79 words (25 before + 54 after)
  {
    pivotWord: "RED",
    difficulty: "medium",
    hints: [
      "Think about shades and colors",
      "Consider warnings and alerts",
      "What things are this color?"
    ],
    validBefore: [
      "beet", "blood", "brick", "bright", "cherry", "code", "crimson", "dark", "deep",
      "fire", "flame", "infra", "light", "pure", "rose", "ruby", "rust", "scarlet",
      "signal", "solid", "tomato", "turn", "warm", "wine", "dull"
    ],
    validAfter: [
      "alert", "ant", "blood", "bone", "brick", "bud", "cap", "card", "carpet", "coat",
      "cross", "currant", "deer", "dish", "dog", "eye", "face", "fish", "flag", "giant",
      "hair", "handed", "head", "herring", "hot", "ink", "letter", "light", "line",
      "lining", "meat", "neck", "nose", "oak", "pencil", "pepper", "pill", "pine",
      "riding", "rose", "shift", "skin", "snapper", "start", "state", "tape", "tide",
      "top", "wine", "wing", "wood", "zone", "breast", "tail"
    ]
  },

  // ROOM - 117 words (113 before + 4 after)
  {
    pivotWord: "ROOM",
    difficulty: "medium",
    hints: [
      "Think about spaces in buildings",
      "Consider purposes and functions",
      "What types of rooms exist?"
    ],
    validBefore: [
      "back", "ball", "bath", "bed", "board", "boiler", "box", "break", "changing",
      "chart", "chat", "check", "class", "clean", "cloak", "club", "coat", "cold",
      "common", "conference", "control", "copy", "court", "cutting", "dark", "dining",
      "drawing", "dressing", "elbow", "emergency", "engine", "exam", "family", "file",
      "fitting", "front", "game", "green", "guest", "gun", "head", "home", "hospital",
      "hot", "laundry", "leg", "living", "locker", "lumber", "lunch", "mail", "map",
      "meeting", "mud", "music", "news", "night", "operating", "outer", "powder",
      "press", "private", "pump", "reading", "ready", "rec", "reception", "recovery",
      "rest", "robing", "sales", "sample", "screen", "server", "service", "ship",
      "show", "sitting", "staff", "state", "steam", "stock", "storage", "store",
      "strong", "study", "sun", "supply", "tack", "tap", "tea", "throne", "tool",
      "trunk", "utility", "vat", "waiting", "war", "ward", "ware", "wash", "weight",
      "wheel", "wine", "work", "ante", "bar", "billiard", "book", "bride", "chess",
      "choir"
    ],
    validAfter: [
      "mate", "service", "temperature", "key"
    ]
  },

  // SHORT - 32 words (5 before + 27 after)
  {
    pivotWord: "SHORT",
    difficulty: "medium",
    hints: [
      "Think about length and duration",
      "Consider deficiencies and lacks",
      "What is brief or small?"
    ],
    validBefore: [
      "ultra", "fall", "running", "dollar", "sell"
    ],
    validAfter: [
      "bread", "cake", "change", "circuit", "coming", "cut", "fall", "hand", "list",
      "lived", "stop", "term", "wave", "sighted", "stack", "age", "arm", "course",
      "form", "hair", "haul", "horn", "line", "order", "range", "ribs", "run"
    ]
  },

  // SIDE - 105 words (70 before + 35 after)
  {
    pivotWord: "SIDE",
    difficulty: "medium",
    hints: [
      "Think about directions and positions",
      "Consider edges and margins",
      "What has sides?"
    ],
    validBefore: [
      "back", "bed", "blind", "broad", "dark", "down", "in", "out", "ring", "hill",
      "fire", "along", "bay", "beach", "board", "bright", "country", "court", "creek",
      "curb", "dock", "door", "east", "far", "field", "flip", "front", "grass", "harbor",
      "high", "home", "inside", "lake", "land", "lawn", "lee", "left", "mountain",
      "near", "night", "north", "off", "outside", "over", "park", "pool", "port", "rail",
      "river", "road", "sea", "south", "stage", "star", "state", "store", "stream",
      "street", "sun", "table", "top", "track", "trail", "up", "water", "way", "weak",
      "west", "wind"
    ],
    validAfter: [
      "arm", "bar", "board", "burn", "burns", "car", "dish", "effect", "kick", "light",
      "line", "long", "man", "note", "order", "pocket", "show", "step", "street",
      "stroke", "swipe", "table", "track", "view", "walk", "wall", "ward", "way",
      "winder", "wise", "bet", "door", "glance", "issue"
    ]
  },

  // SILVER - 54 words (14 before + 40 after)
  {
    pivotWord: "SILVER",
    difficulty: "medium",
    hints: [
      "Think about precious metals",
      "Consider colors and shine",
      "What things are silver?"
    ],
    validBefore: [
      "quick", "sterling", "solid", "hammered", "polished", "bright", "burnished",
      "liquid", "molten", "plated", "pure", "real", "shiny", "tarnished"
    ],
    validAfter: [
      "back", "bell", "fish", "fox", "lining", "smith", "spoon", "ware", "screen",
      "dollar", "bullet", "medal", "age", "anniversary", "band", "bar", "birch", "chain",
      "coin", "cord", "cup", "foil", "fork", "hair", "haired", "jubilee", "leaf",
      "maple", "mine", "nitrate", "plate", "plated", "point", "ring", "service", "side",
      "standard", "star", "strip", "tongue"
    ]
  },

  // SKY - 67 words (21 before + 46 after)
  {
    pivotWord: "SKY",
    difficulty: "medium",
    hints: [
      "Think about the atmosphere",
      "Consider weather and views",
      "What's above us?"
    ],
    validBefore: [
      "blue", "clear", "cloudy", "dark", "gray", "night", "open", "stormy", "bright",
      "cloudless", "dawn", "dusk", "evening", "midnight", "morning", "overcast", "pale",
      "southern", "summer", "twilight", "winter"
    ],
    validAfter: [
      "blue", "cap", "dive", "diver", "diving", "high", "jack", "lark", "light", "line",
      "lit", "rocket", "scraper", "walk", "walker", "ward", "watch", "way", "writing",
      "borne", "bound", "box", "bridge", "camera", "car", "clad", "color", "dome",
      "fall", "gazer", "gazing", "glow", "god", "hook", "jumping", "lift", "lounge",
      "map", "marshal", "pilot", "rail", "rise", "sail", "scape", "sign", "surf"
    ]
  },

  // SNOW - 86 words (23 before + 63 after)
  {
    pivotWord: "SNOW",
    difficulty: "medium",
    hints: [
      "Think about winter weather",
      "Consider cold and ice",
      "What involves snow?"
    ],
    validBefore: [
      "heavy", "fresh", "deep", "wet", "powder", "melting", "blowing", "drifting",
      "falling", "first", "hard", "late", "light", "new", "packed", "soft", "spring",
      "thick", "white", "winter", "corn", "dry", "fluffy"
    ],
    validAfter: [
      "ball", "bank", "bird", "blind", "board", "bound", "cap", "capped", "cat", "clad",
      "cone", "covered", "craft", "drift", "drop", "fall", "field", "flake", "goose",
      "job", "leopard", "line", "man", "melt", "mobile", "pack", "pea", "plow", "plowed",
      "plowing", "removal", "shoe", "shovel", "slide", "storm", "suit", "tire", "white",
      "belt", "berry", "blower", "boot", "bunny", "chain", "day", "dog", "fence", "fort",
      "gear", "globe", "gun", "hare", "house", "load", "maker", "proof", "scape", "shed",
      "sports", "squall", "throw", "thrower"
    ]
  },

  // STAR - 89 words (47 before + 42 after)
  {
    pivotWord: "STAR",
    difficulty: "medium",
    hints: [
      "Think about celebrities and fame",
      "Consider astronomy and space",
      "What shines or stands out?"
    ],
    validBefore: [
      "all", "co", "day", "eye", "film", "five", "four", "gold", "guest", "lone", "mega",
      "morning", "movie", "north", "pop", "porn", "rock", "sea", "shooting", "soap",
      "super", "tennis", "tv", "action", "basketball", "big", "bright", "child",
      "dancing", "dark", "death", "dim", "distant", "double", "falling", "fixed", "folk",
      "football", "giant", "guiding", "hockey", "infant", "local", "lucky", "main",
      "opera", "pole"
    ],
    validAfter: [
      "board", "burst", "dom", "dust", "fish", "fruit", "gaze", "gazer", "gazing", "let",
      "light", "like", "ling", "lit", "power", "ship", "struck", "beam", "born", "bright",
      "crossed", "fire", "flower", "gate", "maker", "man", "port", "seed", "shine",
      "sight", "sign", "spangled", "spot", "studded", "tracker", "wars", "watching",
      "way", "wise", "witness", "wort"
    ]
  },

  // STONE - 96 words (66 before + 30 after)
  {
    pivotWord: "STONE",
    difficulty: "medium",
    hints: [
      "Think about rocks and minerals",
      "Consider building and construction",
      "What kinds of stones exist?"
    ],
    validBefore: [
      "corner", "cobble", "grave", "hail", "lime", "mile", "moon", "sand", "stepping",
      "birth", "blood", "blue", "brown", "cap", "cherry", "concrete", "coping", "curb",
      "cut", "drift", "dry", "end", "field", "fire", "flag", "floor", "foundation",
      "free", "gall", "gem", "grind", "ground", "head", "heart", "holly", "iron", "key",
      "kidney", "land", "living", "load", "lodge", "mark", "mill", "mud", "oil", "oval",
      "paving", "plum", "precious", "pumice", "quarry", "river", "rolling", "rough",
      "rune", "soap", "solid", "sun", "tomb", "touch", "whet", "white", "yard"
    ],
    validAfter: [
      "wall", "work", "ware", "mason", "cold", "washed", "fruit", "age", "cutter",
      "throw", "blind", "broke", "carving", "chat", "circle", "craft", "crop", "crusher",
      "dead", "deaf", "face", "fish", "fly", "ground", "hard", "henge", "like", "lined",
      "pit", "wash"
    ]
  },

  // SUN - 76 words (17 before + 59 after)
  {
    pivotWord: "SUN",
    difficulty: "medium",
    hints: [
      "Think about light and warmth",
      "Consider daytime and weather",
      "What relates to the sun?"
    ],
    validBefore: [
      "bright", "hot", "mid", "morning", "noon", "rising", "setting", "afternoon",
      "blazing", "direct", "early", "evening", "full", "golden", "late", "low", "warm"
    ],
    validAfter: [
      "bath", "bathe", "beam", "bed", "bird", "block", "bonnet", "bow", "burn", "burnt",
      "burst", "cream", "dance", "dew", "dial", "dog", "down", "dress", "dried", "dry",
      "fish", "flower", "glasses", "glow", "god", "hat", "kissed", "lamp", "land",
      "less", "light", "lit", "lounger", "proof", "ray", "rise", "roof", "room",
      "screen", "seeker", "set", "shade", "shine", "spot", "star", "stone", "stroke",
      "tanned", "trap", "umbrella", "up", "visor", "ward", "worship", "baked", "bathing",
      "beamed", "belt", "deck"
    ]
  },

  // TIME - 149 words (105 before + 44 after)
  {
    pivotWord: "TIME",
    difficulty: "medium",
    hints: [
      "Think about duration and schedules",
      "Consider moments and periods",
      "What relates to time?"
    ],
    validBefore: [
      "air", "bed", "big", "break", "crunch", "day", "dinner", "down", "drive", "face",
      "first", "flex", "full", "good", "half", "harvest", "idle", "key", "last", "late",
      "lead", "leisure", "life", "local", "long", "lunch", "mean", "meal", "movie",
      "nap", "night", "old", "one", "over", "part", "past", "peace", "peak", "play",
      "present", "prime", "quality", "question", "quiet", "race", "real", "run",
      "screen", "seed", "short", "show", "sleep", "small", "some", "space", "spare",
      "spring", "stop", "story", "summer", "supper", "tea", "travel", "turnaround",
      "two", "wait", "war", "waste", "winter", "work", "all", "alone", "any", "arrival",
      "baking", "bath", "best", "birth", "block", "board", "bomb", "bonus", "brew",
      "busy", "buy", "call", "check", "class", "closing", "coffee", "cook", "core",
      "count", "course", "curtain", "cut", "date", "dead", "delay", "delivery",
      "development"
    ],
    validAfter: [
      "bomb", "card", "frame", "keeper", "lapse", "less", "line", "out", "piece",
      "saver", "scale", "share", "sheet", "table", "warp", "worn", "zone", "bound",
      "capsule", "clock", "code", "conscious", "consuming", "critical", "delay",
      "honored", "lag", "limit", "lock", "management", "off", "period", "saving",
      "sensitive", "server", "shift", "slot", "span", "stamp", "tested", "travel",
      "trial", "waster"
    ]
  },

  // TOOTH - 57 words (35 before + 22 after)
  {
    pivotWord: "TOOTH",
    difficulty: "medium",
    hints: [
      "Think about dental and oral",
      "Consider types and conditions",
      "What describes teeth?"
    ],
    validBefore: [
      "buck", "eye", "gap", "saber", "saw", "sweet", "snag", "baby", "wisdom", "back",
      "bad", "big", "broken", "canine", "chipped", "dead", "dog", "false", "front",
      "gold", "hound", "loose", "lost", "lower", "milk", "missing", "molar", "permanent",
      "rotten", "sharp", "single", "sore", "upper", "wolf", "yellow"
    ],
    validAfter: [
      "ache", "brush", "paste", "pick", "some", "fairy", "comb", "cup", "decay",
      "doctor", "enamel", "extraction", "filling", "glass", "guard", "mark", "pain",
      "plate", "powder", "pulling", "root", "whitening"
    ]
  },

  // WATCH - 57 words (32 before + 25 after)
  {
    pivotWord: "WATCH",
    difficulty: "medium",
    hints: [
      "Think about timepieces",
      "Consider observation and guarding",
      "What involves watching?"
    ],
    validBefore: [
      "bird", "death", "fire", "night", "stop", "wrist", "anchor", "bay", "clock",
      "coast", "crime", "deck", "digital", "dog", "dress", "face", "fashion", "field",
      "fob", "gold", "grandfather", "harbor", "head", "hurricane", "market", "middle",
      "neighborhood", "pocket", "quartz", "sky", "sport", "weight"
    ],
    validAfter: [
      "band", "dog", "maker", "man", "tower", "word", "box", "cap", "case", "chain",
      "crystal", "dial", "face", "fire", "guard", "hand", "keeping", "list", "pocket",
      "repair", "shop", "spring", "strap", "winder", "works"
    ]
  },

  // WATER - 157 words (69 before + 88 after)
  {
    pivotWord: "WATER",
    difficulty: "medium",
    hints: [
      "Think about liquids and hydration",
      "Consider bodies of water",
      "What involves H2O?"
    ],
    validBefore: [
      "rain", "dish", "salt", "fresh", "holy", "tap", "spring", "waste", "ground",
      "mineral", "sea", "back", "bath", "black", "blue", "body", "boiling", "bottled",
      "brackish", "branch", "break", "carbonated", "city", "clean", "clear", "cloudy",
      "coastal", "cold", "cool", "county", "creek", "deep", "dirty", "distilled",
      "drain", "drinking", "drip", "eye", "fire", "fizzy", "flood", "fluoridated",
      "fountain", "frozen", "gray", "hard", "head", "high", "hot", "ice", "in",
      "inland", "lake", "lime", "low", "mouth", "mud", "ocean", "open", "pond", "pool",
      "port", "purified", "river", "rose", "running", "shallow"
    ],
    validAfter: [
      "bed", "bird", "borne", "boy", "buffalo", "bug", "cannon", "color", "cooler",
      "course", "craft", "cress", "cycle", "dog", "dragon", "drop", "fall", "fast",
      "filter", "flow", "fowl", "front", "gate", "gun", "heater", "hole", "hose",
      "level", "lily", "line", "logged", "main", "man", "mark", "melon", "meter",
      "mill", "pipe", "pistol", "polo", "power", "proof", "pump", "quality", "rat",
      "resistant", "rights", "scooter", "shed", "side", "ski", "slide", "snake",
      "spout", "sports", "spot", "sprite", "supply", "table", "tank", "taxi", "tight",
      "tower", "treatment", "vapor", "way", "weed", "wheel", "wings", "witch", "work",
      "works", "world", "worth", "balloon", "based", "bladder", "boarding", "bottle",
      "bound", "break", "bucket", "carrier", "chestnut", "clock"
    ]
  },

  // WHITE - 99 words (20 before + 79 after)
  {
    pivotWord: "WHITE",
    difficulty: "medium",
    hints: [
      "Think about colors and purity",
      "Consider things that are light",
      "What is white?"
    ],
    validBefore: [
      "egg", "off", "snow", "lily", "pure", "bright", "bone", "chalk", "cream", "ghost",
      "ivory", "milk", "pale", "paper", "pearl", "pearly", "plain", "powder", "solid",
      "stark"
    ],
    validAfter: [
      "board", "cap", "collar", "fish", "hall", "head", "hot", "house", "lie", "out",
      "paper", "sauce", "space", "wash", "water", "noise", "ant", "ash", "bait", "ball",
      "bass", "bear", "birch", "blood", "bread", "cell", "chocolate", "christmas",
      "coat", "corn", "dwarf", "elephant", "eye", "face", "feather", "flag", "flight",
      "flour", "fly", "gold", "goods", "grape", "hair", "haired", "hawk", "heat",
      "horse", "knight", "label", "lead", "light", "line", "list", "magic", "meat",
      "metal", "oak", "pages", "paint", "pine", "plague", "rice", "room", "sale",
      "shark", "sheet", "smith", "spot", "sugar", "tail", "tie", "tip", "trash", "wall",
      "wedding", "wine", "witch"
    ]
  },

  // WIND - 71 words (28 before + 43 after)
  {
    pivotWord: "WIND",
    difficulty: "medium",
    hints: [
      "Think about air and weather",
      "Consider energy and movement",
      "What involves wind?"
    ],
    validBefore: [
      "head", "tail", "whirl", "cross", "down", "trade", "solar", "back", "chinook",
      "cold", "contrary", "cool", "desert", "dry", "east", "fair", "foul", "fresh",
      "gale", "gentle", "high", "hot", "ill", "light", "north", "offshore", "prevailing",
      "second"
    ],
    validAfter: [
      "bag", "break", "chill", "fall", "mill", "pipe", "shield", "sock", "storm",
      "swept", "ward", "farm", "age", "blown", "borne", "bound", "breaker", "burn",
      "burned", "burner", "catcher", "chime", "coat", "drift", "energy", "erosion",
      "flower", "gap", "gust", "milling", "power", "proof", "row", "sail", "screen",
      "shear", "speed", "surfer", "surfing", "tunnel", "turbine", "vane"
    ]
  },

  // WORD - 54 words (37 before + 17 after)
  {
    pivotWord: "WORD",
    difficulty: "medium",
    hints: [
      "Think about language and speech",
      "Consider writing and text",
      "What involves words?"
    ],
    validBefore: [
      "cross", "pass", "buzz", "code", "fore", "key", "watch", "catch", "swear",
      "action", "base", "big", "borrowed", "by", "choice", "coined", "compound", "core",
      "cue", "cuss", "dirty", "empty", "exact", "fair", "fancy", "final", "first",
      "four-letter", "guide", "harsh", "household", "hurtful", "kind", "last", "loan",
      "magic", "power"
    ],
    validAfter: [
      "book", "play", "smith", "press", "perfect", "search", "processor", "age",
      "count", "craft", "finder", "game", "length", "list", "mark", "master", "wrap"
    ]
  },

  // WORK - 152 words (103 before + 49 after)
  {
    pivotWord: "WORK",
    difficulty: "medium",
    hints: [
      "Think about labor and jobs",
      "Consider effort and tasks",
      "What involves working?"
    ],
    validBefore: [
      "art", "busy", "fire", "foot", "hard", "home", "house", "net", "team", "frame",
      "paper", "brush", "case", "class", "clock", "course", "craft", "day", "desk",
      "detail", "dirty", "donkey", "dream", "earth", "farm", "field", "flat", "free",
      "fret", "glass", "ground", "group", "guess", "hack", "hand", "head", "heart",
      "homework", "hose", "iron", "job", "knee", "knife", "lab", "lace", "land", "lap",
      "lathe", "lattice", "lawn", "lay", "lead", "leather", "leg", "life", "light",
      "line", "machine", "make", "manual", "master", "metal", "mill", "mind", "mine",
      "mop", "motor", "mouse", "muscle", "nail", "needle", "nerve", "network", "night",
      "nose", "office", "oil", "open", "out", "over", "pace", "paint", "pair", "panel",
      "part", "patch", "pattern", "paving", "pen", "pencil", "phone", "pick", "piece",
      "pipe", "plaster", "plate", "play", "police", "post", "press", "probe"
    ],
    validAfter: [
      "able", "book", "day", "force", "horse", "load", "man", "out", "shop", "station",
      "bench", "flow", "about", "around", "bag", "basket", "board", "boat", "camp",
      "card", "clothes", "desk", "group", "house", "life", "mate", "master", "off",
      "over", "pace", "paper", "place", "print", "product", "room", "sheet", "ship",
      "site", "space", "spot", "study", "style", "table", "time", "top", "up", "wear",
      "week", "woman"
    ]
  }
];

// Generate 366 puzzles by cycling through unique puzzles
const puzzles = Array.from({ length: 366 }, (_, i) => {
  const puzzleIndex = i % uniquePuzzles.length;
  const puzzle = uniquePuzzles[puzzleIndex];

  return {
    id: i + 1,
    date: new Date(2025, 0, i + 1).toISOString().split("T")[0],
    ...puzzle,
  };
});

export default puzzles;
